import React, { useState, useEffect, useMemo } from "react";

import ParagraphList from "./ParagraphList";
import ParagraphBox from "./ParagraphBox";
import CloseButton from "../../../../../components/CloseButton";
import ReviewSettingsPanel from "../../../../../components/ReviewSettingsPanel";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 반응형: PC 좌우 분할 → 모바일 상하 분할 (WorksheetModalV2.css)
 * 2. 모의고사 복습 설정: 압축 체크박스 바 → 단어테스트와 동일한
 *    풀 패널(ReviewSettingsPanel)로 교체. 지문 미리보기 아래 스크롤 영역에 배치.
 * 3. 하단 바는 이전/다음 버튼만.
 */
const ParagraphSelectionPage = ({
  worksheet,
  onClose,
  onClickPrev,
  onClickNext,
  selectedTypes,
  selectedParagraphs,
  setSelectedParagraphs,
  isRetryEnabled,
  setIsRetryEnabled,
  isAutoRetryEnabled,
  setIsAutoRetryEnabled,
  maxRetries,
  setMaxRetries,
}) => {
  const worksheetData = useMemo(() => {
    if (worksheet.type === "comprehensive") {
      const examIndex =
        selectedTypes.find((type) => type.key === "comprehensive")?.index || 1;
      return worksheet.data[examIndex - 1];
    } else {
      return worksheet.data;
    }
  }, [worksheet.type, worksheet.data, selectedTypes]);

  const [activeParagraph, setActiveParagraph] = useState(worksheetData[0]);

  useEffect(() => {
    setSelectedParagraphs(worksheetData.map((_, i) => i));
  }, [setSelectedParagraphs, worksheetData]);

  return (
    <div
      className="ws-paragraph-layout"
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      <CloseButton onClick={onClose} />

      {/* 왼쪽: 지문 목록 */}
      <ParagraphList
        worksheetData={worksheetData}
        worksheetTitle={worksheet.title}
        activeParagraph={activeParagraph}
        setActiveParagraph={setActiveParagraph}
        selectedParagraphs={selectedParagraphs}
        setSelectedParagraphs={setSelectedParagraphs}
      />

      {/* 오른쪽: 지문 내용 + 복습 패널 + 하단 바 */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <div
          className="ws-scroll"
          style={{ flex: 1, minHeight: 0, padding: "10px 16px", overflowY: "auto", WebkitOverflowScrolling: "touch" }}
        >
          {activeParagraph ? (
            <ParagraphBox paragraph={activeParagraph} type={worksheet.type} />
          ) : (
            <p style={{ color: "#7A8490", padding: "14px" }}>
              목록에서 지문을 눌러주세요.
            </p>
          )}

          {/* 모의고사: 복습 설정 풀 패널 (단어테스트와 동일 UI) */}
          {worksheet.type === "paragraph" && (
            <div style={{ margin: "6px 0 16px", maxWidth: "560px" }}>
              <ReviewSettingsPanel
                isRetryEnabled={isRetryEnabled}
                onToggleRetry={() => setIsRetryEnabled(!isRetryEnabled)}
                isAutoRetryEnabled={isAutoRetryEnabled}
                onSetAutoRetry={setIsAutoRetryEnabled}
                maxRetries={maxRetries}
                onSetMaxRetries={setMaxRetries}
              />
            </div>
          )}
        </div>

        {/* 하단 바: 버튼만 */}
        <div className="ws-bottom-bar" style={{ justifyContent: "flex-end" }}>
          {onClickPrev && (
            <button className="ws-btn-prev" onClick={onClickPrev}>
              이전
            </button>
          )}
          <button
            className="ws-btn-next"
            style={{ flex: "none", padding: "11px 42px" }}
            onClick={onClickNext}
          >
            다음
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParagraphSelectionPage;
